import { render } from "./DetailPanel.vue?vue&type=template&id=cb110334&scoped=true"
import script from "./DetailPanel.vue?vue&type=script&lang=js"
export * from "./DetailPanel.vue?vue&type=script&lang=js"

import "./DetailPanel.vue?vue&type=style&index=0&id=cb110334&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb110334"]])

export default __exports__